import { ServiceProvider } from "../core/provider/service-provider";
import { Logger } from "../logger/logger";

type Dictionary = { [key: string]: string };

export class Translator {
	public static async fromUrlAsync(url: string, areaName: string, resourceName: string, culture: string): Promise<Translator> {
		if (!url) {
			throw new Error("Missing url for translator");
		}

		let cache: { [key: string]: Promise<Dictionary> } = (window as any).localization ??= {};
		let cacheKey = areaName + "-" + resourceName + "-" + culture;
		let cachedItem = cache[cacheKey];

		let dict: Dictionary = null;

		try {
			if (cachedItem) {
				dict = await cachedItem;
			}
			if (!dict) {
				cachedItem = cache[cacheKey] = ServiceProvider.ajax.jsonAsync({ url, params: { areaName, resourceName, culture }, cache: true });
				dict = await cachedItem;
			}
		} catch (e) {
			Logger.warn("Failed to download language table", url, e);
			if (e.status !== 404) {
				throw e;
			}
		}

		dict ??= {};
		return new Translator(dict);
	}

	constructor(private data: Dictionary) {
	}

	public translate(key: string): string {
		return (this.data[key] || key);
	}

	public translateOrDefault(key: string, defaultValue: string): string {
		return (this.data[key] || defaultValue);
	}
}